import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckListsPageComponent } from './components/check-lists-page/check-lists-page.component';
import { CheckListsPageRoutingModule } from './check-lists-page-routing.module';
import { AppUiModule } from '../../ui/app-ui.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [CheckListsPageComponent],
  imports: [CommonModule, RouterModule, CheckListsPageRoutingModule, AppUiModule],
})
export class CheckListsPageModule {}
